<template>
  <section class="colored section no-padding-mobile">
    <p>{{ $t('Los campos marcados con asterisco (*) son obligatorios.') }}</p>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(validateBeforeSubmit)">
        <b-field grouped group-multiline>
          <b-field expanded :label="$t('Nombre de la compañía') + '*'">
            <ValidationProvider
              name="Name"
              rules="required"
              v-slot="{ errors }"
            >
              <b-input expanded v-model="formData.company.name"></b-input>
              <p v-show="errors.length" class="help is-danger">
                {{ $t('Nombre no válido') }}
              </p>
            </ValidationProvider>
          </b-field>

          <b-field expanded :label="$t('Fecha fundación') + '*'">
            <ValidationProvider
              name="Fundation date"
              rules="required"
              v-slot="{ errors }"
            >
              <b-input
                expanded
                type="text"
                placeholder="dd/mm/yyyy"
                v-model="formData.company.fundationDate"
              ></b-input>
              <p v-show="errors.length" class="help is-danger">
                {{ $t('Seleccione fecha de fundación') }}
              </p>
            </ValidationProvider>
          </b-field>
        </b-field>
        <b-field grouped group-multiline>
          <b-field
            :label="$t('Tamaño del equipo') + '*'"
            style="flex-shrink: .8 !important;"
          >
            <ValidationProvider
              name="Team size"
              rules="required|numeric"
              v-slot="{ errors }"
            >
              <b-input
                type="number"
                v-model="formData.company.teamSize"
              ></b-input>
              <p v-show="errors.length" class="help is-danger">
                {{ $t('Tamaño del equipo no válido') }}
              </p>
            </ValidationProvider>
          </b-field>

          <b-field expanded :label="$t('Sector') + '*'">
            <ValidationProvider
              name="Sector"
              rules="required"
              v-slot="{ errors }"
            >
              <b-select expanded v-model="formData.company.sector">
                <option
                  v-for="sector in dataOptions.economicSectors"
                  :key="sector.id"
                  :value="sector.id"
                >
                  {{ $t(sector.id).replace(/#/g, ' ') }}
                </option>
              </b-select>
              <p v-show="errors.length" class="help is-danger">
                {{ $t('Seleccione sector') }}
              </p>
            </ValidationProvider>
          </b-field>
        </b-field>

        <b-field grouped group-multiline>
          <b-field expanded :label="$t('Actividad en sector').replace(/#/g, ' ') + '*'">
            <ValidationProvider
              name="Activity in sector"
              rules="required"
              v-slot="{ errors }"
            >
              <b-select
                :disabled="!formData.company.sector"
                expanded
                v-model="formData.company.activityInSector"
              >
                <option
                  v-for="activity in filteredBusinessSectors"
                  :key="activity.id"
                  :value="activity.id"
                >
                  {{ $t(activity.id).replace(/#/g, ' ') }}
                </option>
              </b-select>
              <p v-show="errors.length" class="help is-danger">
                {{ $t('Seleccione actividad') }}
              </p>
            </ValidationProvider>
          </b-field>
        </b-field>
        <b-field :label="$t('Nombre del proyecto')">
          <b-input expanded v-model="formData.proposal"></b-input>
        </b-field>
        <b-field :label="$t('Descripción breve del proyecto')">
          <b-input
            expanded
            v-model="formData.proposalDescription"
            type="textarea"
          ></b-input>
        </b-field>

        <b-field grouped group-multiline>
          <b-field expanded :label="$t('Website URL')">
            <b-input expanded v-model="formData.website"></b-input>
          </b-field>

          <b-field expanded :label="$t('Enlace video')">
            <b-input expanded v-model="formData.videoLink"></b-input>
          </b-field>
        </b-field>
        <b-field :label="$t('Los 3 competidores principales')">
          <b-input expanded v-model="formData.competitors"></b-input>
        </b-field>
        <b-field grouped group-multiline>
          <b-field :label="$t('¿Ya tienes ingresos?')">
            <div class="block">
              <b-radio v-model="formData.alreadyIncome" native-value="true">{{
                $t('Sí')
              }}</b-radio>
              <b-radio v-model="formData.alreadyIncome" native-value="false">{{
                $t('No')
              }}</b-radio>
            </div>
          </b-field>
          <b-field label="¿Tienes clientes?">
            <div class="block">
              <b-radio
                v-model="formData.alreadyClients"
                name="name"
                native-value="true"
                >{{ $t('Sí') }}</b-radio
              >
              <b-radio
                v-model="formData.alreadyClients"
                name="name"
                native-value="false"
                >{{ $t('No') }}</b-radio
              >
            </div>
          </b-field>
        </b-field>
        <div class="has-text-centered">
          <b-button size="is-large" native-type="submit" type="is-primary">{{
            $t('Guardar')
          }}</b-button>
        </div>
      </form>
    </ValidationObserver>
  </section>
</template>
<script>
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import economicSectors from '@/constants/economic_sectors'
import businessSectors from '@/constants/business_sectors'

import {
  required,
  alpha,
  numeric,
  email,
  confirmed
} from 'vee-validate/dist/rules'

extend('required', {
  ...required
})

extend('alpha', {
  ...alpha
})

extend('numeric', {
  ...numeric
})

extend('email', {
  ...email
})

extend('confirmed', {
  ...confirmed
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    basicDetails: {
      type: Object,
      default: function() {
        return {
          company: {
            name: null,
            fundationDate: null,
            teamSize: null,
            sector: null,
            activityInSector: null
          },
          proposal: null,
          proposalDescription: null,
          website: null,
          videoLink: null,
          competitors: null,
          alreadyIncome: null,
          alreadyClients: null
        }
      }
    }
  },
  data() {
    return {
      dataOptions: {
        economicSectors,
        businessSectors
      },
      formData: {}
    }
  },
  watch: {
    basicDetails: function(val) {
      this.formData = val
    }
  },
  beforeMount() {
    this.formData = this.basicDetails
  },
  methods: {
    validateBeforeSubmit() {
      this.$emit('formSubmit', { basicDetails: this.formData })
    }
  },
  computed: {
    filteredBusinessSectors() {
      let self = this
      if (self.formData.company.sector) {
        return self.dataOptions.businessSectors.filter(el =>
          el.parents.includes(self.formData.company.sector)
        )
      } else {
        return []
      }
    }
  }
}
</script>

<style scoped>
.field.is-grouped {
  flex-wrap: wrap;
}
</style>
